import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { parseQueryParams } from "utils/misc";

export default function useQueryParams() {
  const location = useLocation();
  return useMemo(() => parseQueryParams(location.search), [location.search]);
}
